import {PredicateOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ClientRuleCondition} from '../../rules/ruleConditionModel';

/*
 * Type enum.
 */

export enum ConditionsActionTypesEnum {
  ADD_CONDITION = '@@conditions/ADD',
  UPDATE_CONDITION = '@@conditions/UPDATE',
  DELETE_CONDITION = '@@conditions/DELETE',
}

/*
 * Types.
 */

interface AddCondition {
  type: ConditionsActionTypesEnum.ADD_CONDITION;
  indexAND: number;
  condition: ClientRuleCondition;
}

interface UpdateCondition {
  type: ConditionsActionTypesEnum.UPDATE_CONDITION;
  indexAND: number;
  predicate: PredicateOf<ClientRuleCondition>;
  update(cond: ClientRuleCondition): ClientRuleCondition;
}

interface DeleteCondition {
  type: ConditionsActionTypesEnum.DELETE_CONDITION;
  indexAND: number;
  predicate: PredicateOf<ClientRuleCondition>;
}

/*
 * Combined action type.
 */

export type ConditionAction = AddCondition | UpdateCondition | DeleteCondition;
